"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputKeyDerived = void 0;
const KHInputKey_1 = require("./KHInputKey");
class KHInputKeyDerived extends KHInputKey_1.KHInputKey {
    constructor(inputSet) {
        super();
        if (inputSet) {
            inputSet.addInput(this);
        }
    }
}
exports.KHInputKeyDerived = KHInputKeyDerived;
